/**
 * DrewCore Main JavaScript
 *
 * Ez a fájl töltődik be ELŐSZÖR a bundleben (components + sections előtt).
 * Globális inicializáció, utility funkciók.
 *
 * Build: Gulp concat → dist/js/main.min.js
 */

(function () {
  'use strict';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    // Per-project: globális init ide
    // Pl.: smooth scroll, back-to-top, stb.
  }

})();
